import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AccountHiringsComponent } from "./account-hirings.component";
import { NzListModule } from "ng-zorro-antd/list";
import { NzGridModule } from "ng-zorro-antd/grid";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [AccountHiringsComponent],
  imports: [CommonModule, NzListModule, NzGridModule, TranslateModule],
  exports: [AccountHiringsComponent],
})
export class AccountHiringsModule {}
